import {useMemo} from "react";
import {Button, Group, Text} from "@mantine/core";
import Icon from "../Icon/Icon.tsx";
import IconMap from "../Icon/IconMap.ts";


interface TravelPlannerProps {
    system: PlannerSystem;
    space: PlannerSpace;
    surface: PlannerSurface;
    ground: PlannerGround;
    label?: string;
}

export default function TravelPlanner({system, space=null, surface=null, ground = null, label=''}: TravelPlannerProps) {
    const link = useMemo(() => generateLink(system, space, surface, ground), [system, space, surface, ground]);

    return (<a href={link} target="_blank" className="travel-planner" title="Travel planner"><Group gap="sm" align="center"><Icon icon={IconMap.TravelPlanner} />{label && <Text span>{label}</Text>}</Group></a> )
}

export function TravelPlannerButton({system, space=null, surface=null, ground = null, label=''}: TravelPlannerProps) {
    return <Button component="a" variant="light" href={generateLink(system, space, surface, ground)} target="_blank" className="travel-planner" title="Travel planner" leftSection={<Icon icon={IconMap.TravelPlanner} />}>{label}</Button>
}

type Location = {x: number, y: number}
type PlannerSystem = Location | {galX: number, galY: number};
type PlannerSpace = Location | {sysX: number, sysY: number} | null;
type PlannerSurface = Location | {surfX: number, surfY: number} | null;
type PlannerGround = Location | {groundX: number, groundY: number} | null;



const generateLink = (system: PlannerSystem, space: PlannerSpace, surface: PlannerSurface, ground: PlannerGround) => {
    let travelClass = 2;
    let coords = "";
    let x,y;
    if('galX' in system && 'galY' in system) {
        x = system.galX;
        y = system.galY;
    } else {
        ({x, y} = system as Location);
    }
    coords = `&galX=${x}&galY=${y}`;

    if(space !== null) {
        let x,y;
        if('sysX' in space && 'sysY' in space) {
            x = space.sysX;
            y = space.sysY;
        } else {
            ({x, y} = space);
        }
        coords += `&sysX=${x}&sysY=${y}`;
    }
    if(surface !== null) {
        travelClass = 1;
        let x,y;
        if('surfX' in surface && 'surfY' in surface) {
            x = surface.surfX;
            y = surface.surfY;
        } else {
            ({x, y} = surface);
        }
        coords += `&surfX=${x}&surfY=${y}`;
    }
    if(ground !== null) {
        travelClass = 0;
        let x,y;
        if('groundX' in ground && 'groundY' in ground) {
            x = ground.groundX;
            y = ground.groundY;
        } else {
            ({x, y} = ground);
        }
        coords += `&groundX=${x}&groundY=${y}`;
    }
    return `https://www.swcombine.com/members/cockpit/travel/directed.php?travelClass=${travelClass}&supplied=1${coords}`;
}

export {generateLink};
